import { render, staticRenderFns } from "./modelAdd.vue?vue&type=template&id=32c0886f&scoped=true"
import script from "./modelAdd.vue?vue&type=script&lang=js"
export * from "./modelAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c0886f",
  null
  
)

export default component.exports